import React, { useEffect } from 'react'
import image from './images/Home_about.avif'
import icon1 from './images/whyChoose/icon-01.png'
import icon2 from './images/whyChoose/icon-02.png'
import icon3 from './images/whyChoose/icon-03.png'
import './Home.css'

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeWhyChoose = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='Home_whychoose_section'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-6 Home_whychoose_section_img'>

                    </div>
                    <div className='col-md-6 Home_whychoose_section_img1'>
                        <img src={image} className='img-fluid' />
                    </div>
                    <div className='col-md-6 Home_whychoose_section_img_content'>
                        <h2>Why chose us</h2>
                        <p className='text-justify'>At Hamo Tech, we are committed to delivering exceptional training that meets the highest standards. Our unique approach to teaching ensures that every student receives personalized attention and guidance. With a focus on hands-on learning and real-world applications, we equip our students with the skills they need to excel in the competitive tech industry.</p>

                        <div>
                            <div className='Home_whychoose_section_img_content1'>
                                <div>
                                    <img src={icon1} />
                                </div>
                                <div data-aos="fade-up" data-aos-duration="2000">
                                    <h4>Popular Courses</h4>
                                    <p className='text-justify'>Our courses are designed to provide the most in-demand skills, empowering you to stay ahead in the fast-paced world of technology. Whether you're looking to master React, Node.js, AWS, or DevOps, we offer cutting-edge training programs that are relevant, effective, and aligned with industry needs. Join our trending courses and set yourself up for success.</p>

                                </div>
                            </div>


                            <div className='Home_whychoose_section_img_content1'>
                                <div>
                                    <img src={icon2} />
                                </div>
                                <div data-aos="fade-up" data-aos-duration="2000">
                                    <h4>Books and the Library</h4>
                                    <p className='text-justify'>Access a wide range of resources in our well-stocked library to enhance your learning experience. From textbooks and reference materials to online resources, we provide everything you need to dive deeper into the world of technology. Stay up-to-date with the latest publications and boost your skills through continuous learning.</p>

                                </div>
                            </div>



                            <div className='Home_whychoose_section_img_content1'>
                                <div>
                                    <img src={icon3} />
                                </div>
                                <div data-aos="fade-up" data-aos-duration="2000">
                                    <h4>Qualified Teachers</h4>
                                    <p className='text-justify'>Our instructors are certified experts with extensive industry experience. They bring real-world knowledge to the classroom, ensuring that the training you receive is both practical and relevant. At Hamo Tech, you’ll learn from the best, gaining insights from professionals who have worked at top tech companies.</p>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeWhyChoose
